import React, { } from "react";
import {Select,Button,Pagination} from "antd"
import {AppTableContext} from "./AppTable"

export interface Props {
    current:number;
    pageSize:number;
    total:number;
}

export class AppPagination extends React.Component<Props> {
    state = { current:this.props.current || 1, pageSize:this.props.pageSize||10 };

    onCurrentChange=(pageNumber:number,context:AppTableContext)=> {
        if(this.props.current === pageNumber) return;
        context.hanldPagination(pageNumber,this.state.pageSize);
        this.setState({current:pageNumber})
    }

    onPageSizeChange = (pageSize:number,context:AppTableContext) =>{
        if(this.state.pageSize===pageSize) return;
        context.hanldPagination(1,pageSize);
        this.setState({pageSize,current:1})
   }

   renderPagination = (context:AppTableContext) =>{
      return  <div className="app-table-pagination-container">
                  <div className="app-table-pagination">
                    <div className="app-table-pagination-left">
                      <span style={{marginRight:10}}>{`共 ${this.props.total} 条`}</span>
                      <Select value={this.state.pageSize} style={{width:110}} onChange={(pageSize:number)=>this.onPageSizeChange(pageSize,context)}>
                        <Select.Option value={10}>10 条/页</Select.Option>
                        <Select.Option value={20}>20 条/页</Select.Option>
                        <Select.Option value={50}>50 条/页</Select.Option>
                        <Select.Option value={100}>100 条/页</Select.Option>
                      </Select>
                    </div>
                    <div className="app-table-pagination-right">
                      <Pagination showQuickJumper 
                      current={this.state.current} 
                      total={this.props.total} 
                      pageSize={this.state.pageSize} 
                      onChange={(pageNumber:number) => this.onCurrentChange(pageNumber,context)} />
                    </div>
                  </div>
              </div>
   }

    render() {
        return (<AppTableContext.Consumer>{this.renderPagination}</AppTableContext.Consumer>);
      }
		
}






// WEBPACK FOOTER //
// ./src/components/AppTable/AppPagination.tsx